// NOTE: the old hardcoded demo `categories` / `products` / `reviews` / `features`
// arrays that used to live here were removed — they were disconnected placeholder
// data that never matched what the admin panel showed. Real products and
// categories now come from the CMS database via `src/context/CatalogContext.tsx`.
// This file only keeps the static gallery photo list, which isn't editable in
// the admin panel.

export const galleryImages = [
  '/fotke/file_000000000ae8724386e93c2983e9df3b.jpg',
  '/fotke/IMG-ca62312854c99b759f61aa6d31a97ba7-V.jpg',
  '/fotke/IMG-bb084af10f3ab244636ad6a284bf89da-V.jpg',
  '/fotke/IMG-749e5d11318c53357184d05916d15147-V.jpg',
  '/fotke/IMG-446bac9aee6e47388e4e77b41eeaea12-V.jpg',
  '/fotke/IMG_20260530_145216.jpg',
];
